import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import { fadeUp } from '../../utils/motion';
type RelatedInitiativeProps = {
  name: string;
  body: string;
  href: string;
  status?: string;
  label?: string;
  linkLabel?: string;
};
export function RelatedInitiative({
  name,
  body,
  href,
  status,
  label = 'Related Project',
  linkLabel
}: RelatedInitiativeProps) {
  return <section aria-label={label} className="bg-surface-bg border-t border-line py-14 lg:py-16" data-id="element-1312" data-mp="1gemwqtks5230">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 items-center" data-id="element-1313" data-mp="1ldr5xk7peztc">
        <div className="lg:col-span-5" data-id="element-1314" data-mp="1v4c4x8rai6cs">
          <p className="text-sm font-medium text-teal mb-2" data-id="element-1315" data-mp="1v7geklnixuau">{label}</p>
          <div className="flex flex-wrap items-center gap-3" data-id="element-1316" data-mp="1z8tj8sevrrg6">
            <h2 className="font-heading font-bold text-2xl lg:text-3xl text-ink-dark tracking-tight" data-id="element-1317" data-mp="245k21ni2l15a">{name}</h2>
            {status && <StatusBadge data-id="element-1318" data-mp="1cthwahcy7jyu">{status}</StatusBadge>}
          </div>
        </div>
        <div className="lg:col-span-7 flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-10" data-id="element-1319" data-mp="18qvbv1ilx1bo">
          <p className="text-lg text-ink-dark leading-relaxed" data-id="element-1320" data-mp="13r8ohz92e4p5">{body}</p>
          <a href={href} className="shrink-0 inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-1321" data-mp="ysxg7syf4291">
            {linkLabel ?? `Explore ${name}`}
            <ArrowRight size={16} aria-hidden="true" data-id="element-1322" data-mp="1mp1tr875uqpp" />
          </a>
        </div>
      </motion.div>
    </section>;
}